
import React, { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BROWSER_SET_DIMENSTION } from '../constants';
import { getCookie, setCookie } from './CookieHandler';

export const BrowserSize = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        window.addEventListener("resize", () => {
            let currentWidth = window.innerWidth;
            let savedInnerWidth = +getCookie("iW");
            if (currentWidth !== savedInnerWidth) {
                if ((currentWidth < 600 && savedInnerWidth > 600) ||
                    ((currentWidth > 600 && currentWidth < 1024) && (savedInnerWidth < 600 || savedInnerWidth > 1023)) ||
                    (currentWidth > 1023 && savedInnerWidth < 1024)) {
                    dispatch(SetBrowserDimension({
                        innerWidth: currentWidth,
                        innerHeight: window.innerHeight
                    }))
                    setCookie("iW", currentWidth);
                }
            }
        })
    }, [])

    const SetBrowserDimension = (payload) => ({
        type: BROWSER_SET_DIMENSTION,
        payload,
    })

    return (
        <Fragment></Fragment>
    )
}